'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils'; 
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { Edit, Trash } from 'lucide-react';
import AddEditController from './addEditController.js';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;
 



export default class LmSobZones extends Component {
  static contextType = LoadingPortContext;

  constructor(props, context) {
    super(props, context);
    this._lastLoadingPortCode = context ? context.loading_port_code : null;
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
          consignmentforceclose:Consignmentforceclose,
          consignmentActions:ConsignmentActions,
          UpdateButton:UpdateButton,
          MarkDeliver : MarkDeliver,
          commentActions : CommentActions,
          actionRenderer: this.ActionRenderer
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        overly:"show-n",
        loadshow:"show-n",
        holidayEvents : [],
        showCalendar : "show-m",
        showGridData : "show-m",
        vehicleCap : [],
        statesList : [],
        zonesList : ["SOUTH","WEST","EAST","NORTH EAST","NORTH","ZONE-1","ZONE-2","ZONE-3","ZONE-4","ZONE-5","ZONE-6","ZONE-7","ZONE-8","ZONE-9","ZONE-10"],
        rowIds : [],
        freight_type : 1,
        comp_code : "",
        lpNames : [],
        loading_port_code : "",
        selectedRows : [],
        controller : {
            open : false
        },
        // In-app confirmation dialog. Replaces window.confirm, which renders the browser's own
        // "20.197.5.130:3005 says" box - out of place beside every other message on this screen
        // (saved / failed / plan status), unstyled, and it blocks the JS thread.
        confirmAlert : {
            open : false,
            title : "",
            message : "",
            confirmText : "Continue",
            type : "warning",
            onConfirm : null
        },
        // Name of the state the grid is currently narrowed to from the duplicate banner ("" = none).
        stateFilterApplied : "",
        errors : [],
        validData : [],
        fileName : "",
        //components : {datepicker:getDatePicker()}
    }
    this.onCellClicked = this.onCellClicked.bind(this);
    this.gridRef = React.createRef();
    this.fileInputRef = React.createRef();
  }

componentDidMount(){
    loadDateTimeScript();
    this.pageAccess();
}

async pageAccess(){
    this.setState({
        loadshow:'show-m',
        overly:'show-m',
    })
    var currentUrl = this.props.match.path;
    var resolved = await resolvePageAccess(currentUrl, this.context);
    if (!resolved) {
        // No access (already alerted+redirected), empty port list, or a logged request error.
        this.setState({ loadshow: 'show-n', overly: 'show-n' });
        return;
    }
    this._lastLoadingPortCode = resolved.loading_port_code;
    this.setState({
        pageAccess: resolved.pageAccess,
        loading_port_code: resolved.loading_port_code,
        comp_code: resolved.comp_code,
        lpNames: resolved.lpNames,
        loadshow: 'show-n',
        overly: 'show-n',
    });
    await this.onLoadPageData();
}

onLoadPageData(){
    var loading_port_code = this.state.loading_port_code;
    var params = {
        loading_port_code : loading_port_code,
    }
    console.log(params,"params")
    
    redirectURL.post("/lmconsignees/getLmStates").then((response)=>{
        var states = response.data;
        var statesList = [];
        if(states.length > 0)
        {
            states.map((item) =>{
                statesList.push(item.state)
            })
        }
        this.setState({
            statesList : statesList,
        })
    }).catch((e)=>{
        console.log(e);
    })
    redirectURL.post("/lmconsignees/getLmSobZones",params).then((response)=>{
        console.log(response.data);
        // Fold in whatever zones are actually already saved for this port -
        // otherwise a zone created via the Add form's "create new" option
        // (see buildSobFormResourceArray) would never show up as a dropdown
        // suggestion again after this first save; the user would have to
        // retype it from scratch every time instead of picking it from the list.
        var usedZones = (response.data || [])
            .map((each) => String(each.zone || "").trim().toUpperCase())
            .filter((z) => z);
        this.setState((prevState) => ({
            rowData : response.data,
            zonesList : [...new Set([...prevState.zonesList, ...usedZones])].sort()
        }))
    }).catch((e)=>{
        console.log(e);
    })
}
    
// ONE STATE -> ONE ZONE. Reports any state in the loaded grid that carries more than one
// zone for this warehouse. Such a record is accepted by every collection and screen, but the
// planning engine resolves a consignee's zone through a { state: zone } dict built over these
// rows (dealer.read_dealer_details), so a duplicate is silently LAST-ROW-WINS: the losing
// consignees plan in the other zone, with its vehicle types, capacities, freight and SOB, and
// nothing anywhere raises an error. Surfacing it on the screen is what lets the master owner
// fix it - the write paths now refuse to create a NEW one, but pre-existing rows remain.
getDuplicateStateZones(){
    var byState = {};
    var defaultOf = {};
    (this.state.rowData || []).forEach((row) => {
        var state = String(row.state || "").trim().toUpperCase();
        var zone = String(row.zone || "").trim().toUpperCase();
        if(!state || !zone) return;
        if(!byState[state]) byState[state] = [];
        if(byState[state].indexOf(zone) === -1) byState[state].push(zone);
        if(Number(row.is_default) === 1) defaultOf[state] = zone;
    });
    return Object.keys(byState)
        .filter((state) => byState[state].length > 1)
        .sort()
        .map((state) => ({ state: state, zones: byState[state].sort(), defaultZone: defaultOf[state] || "" }));
}
// "Yes" when the row is flagged, or when it is the state's ONLY zone (then it is the default
// by definition and no flag is needed).
isDefaultZoneRow(row){
    if(!row) return false;
    if(Number(row.is_default) === 1) return true;
    var state = String(row.state || "").trim().toUpperCase();
    var zones = {};
    (this.state.rowData || []).forEach((r) => {
        if(String(r.state || "").trim().toUpperCase() === state) zones[String(r.zone || "").trim().toUpperCase()] = 1;
    });
    return Object.keys(zones).length === 1;
}

// Narrow the grid to one state so its conflicting records sit side by side and the wrong one
// can be deleted. Uses the grid's own column filter rather than slicing rowData, so Export Data
// and the row checkboxes keep working on exactly what is shown.
// Driven through ag-Grid's EXTERNAL filter, not setFilterModel.
// This grid runs ag-Grid Enterprise, where `filter: true` gives a SET filter by default - it
// ignores a text filter model ({filterType:"text", type:"equals"}), so the banner reported
// "Showing only X" while every row stayed on screen. The external filter is independent of
// whatever filter type a column uses, leaves the user's own column filters alone (they AND
// together), and is honoured by exportDataAsCsv and by the header select-all checkbox - so
// Export and bulk Delete act on exactly the rows being shown.
filterGridToState = (state) => {
    this.setState({ stateFilterApplied: state }, () => {
        if (this.gridApi) this.gridApi.onFilterChanged();
    });
}

clearGridStateFilter = () => {
    this.setState({ stateFilterApplied: "" }, () => {
        if (this.gridApi) this.gridApi.onFilterChanged();
    });
}

isExternalFilterPresent = () => {
    return !!this.state.stateFilterApplied;
}

doesExternalFilterPass = (node) => {
    if (!this.state.stateFilterApplied) return true;
    var rowState = (node && node.data) ? String(node.data.state || "").trim().toUpperCase() : "";
    return rowState === String(this.state.stateFilterApplied).trim().toUpperCase();
}

onGridReady = params => {
    this.gridApi = params.api;
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
};
onGridState = () =>{
        //console.log(this.gridApi);
    
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
                
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
}



closeAlert = async () => {
    await this.setState({
        show: false
    });
    await this.onLoadPageData();
}

// Open the in-app confirmation dialog. `onConfirm` runs only when the user accepts;
// dismissing simply closes it, so the caller never has to undo anything.
askConfirm = (options) => {
    this.setState({
        confirmAlert: {
            open: true,
            title: options.title || "Please confirm",
            message: options.message || "",
            confirmText: options.confirmText || "Continue",
            type: options.type || "warning",
            onConfirm: options.onConfirm || null
        }
    });
}

closeConfirm = () => {
    this.setState({ confirmAlert: { open: false, title: "", message: "", confirmText: "Continue", type: "warning", onConfirm: null } });
}

onConfirmAccepted = () => {
    var action = this.state.confirmAlert.onConfirm;
    this.closeConfirm();
    if (typeof action === "function") {
        action();
    }
}

onCellClicked(e)
{
    if(e.colDef.field == "delete")
    {
        var rowId = e.data._id;
        console.log(e.data._id);
        var qry = {
            rowId:rowId,
            state : e.data.state,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        // Same in-app dialog as every other message on this screen, instead of the browser's
        // own "<host> says" box.
        this.askConfirm({
            title : "Delete this SOB zone record?",
            message : (e.data.state ? e.data.state : "This state")
                + " would then have no zone - its consignees are dropped as \"No Zone Info\".",
            confirmText : "Yes, delete",
            onConfirm : () => {
            redirectURL.post("/lmconsignees/deleteLmSobZones",qry).then((response)=>{
                console.log(response.data);
                if(response.data.message == "Success")
                {
                    this.setState({
                        basicTitle:"Deleted Successfully.",
                        basicType : "success",
                        show : true
                    })
                    //window.location.reload();
                    this.onLoadPageData();
                }
                else
                {
                    this.setState({
                        basicTitle:"Failed to Delete.",
                        basicType : "warning",
                        show : true
                    })
                }
            }).catch((e)=>{
                console.log(e);
            })
            }
        });
    }
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    validData:[],
    errors:[],
    fileName:"",
    });

}
updateLmStates(params)
{
    //console.log(params);
    if(params.state !='' && params.state !=undefined && params.zone !='' && params.zone !=undefined)
    {
        var isEdit = this.state.controller && this.state.controller.type === "update";
        if(isEdit)
        {
            var originalRow = this.state.controller.formData || {};
            var editableFields = (this.state.controller.formResourceArray || []).map((each) => each.field);
            var hasChanges = editableFields.some((field) => (params[field] || "") !== (originalRow[field] || ""));
            if(!hasChanges)
            {
                this.setState({
                    basicTitle:"No Changes Made.",
                    basicType : "warning",
                    show : true,
                    controller : { open : false }
                })
                return;
            }
        }
        else
        {
            // The server keys on (state, ZONE): adding a different zone for a state that
            // already has one ADDS a second row (the NCR / upcountry split), it does not replace
            // the existing one. Confirm, because the state then needs a Default and its cities
            // need placing in Route Configuration.
            var existingZones = (this.state.rowData || []).filter(function(row){
                return String(row.state || "").trim().toUpperCase() === String(params.state || "").trim().toUpperCase();
            }).map(function(row){ return String(row.zone || "").trim().toUpperCase(); });
            var newZone = String(params.zone || "").trim().toUpperCase();
            if(existingZones.length > 0 && existingZones.indexOf(newZone) === -1)
            {
                this.askConfirm({
                    title : "Add " + newZone + " as a second zone for " + params.state + "?",
                    message : params.state + " is already under " + existingZones.join(", ")
                        + ". It will now span more than one zone. List each of its cities under the "
                        + "right zone in Route Configuration, mark ONE zone as the state's Default, and "
                        + "set a Zone on any consignee that must differ from its city.",
                    confirmText : "Yes, add the zone",
                    onConfirm : () => { this.submitLmStates(params, isEdit); }
                });
                return;
            }
        }
        this.submitLmStates(params, isEdit);
    }
    else
    {
        this.setState({
            basicTitle:"Fields Should not be Empty.",
            basicType : "warning",
            show : true
        })
    }
}
// Split out of updateLmStates so the confirmation dialog can call it on accept. The dialog is
// asynchronous (unlike window.confirm, which blocked here), so the save has to resume from a
// callback rather than continue inline.
submitLmStates(params, isEdit)
{
        var  loading_port_code = this.state.loading_port_code;
        params["loading_port_code"] = loading_port_code;
        params['user_name'] = localStorage.getItem('username');
        params['email'] = localStorage.getItem('email');
        params['user_department'] = localStorage.getItem('lm_department');
        params['staff_id'] = localStorage.getItem('staff_id');
        params['designation'] = localStorage.getItem('designation');
        params['comp_code'] = this.state.comp_code;
        params['user_role'] = localStorage.getItem('roles');
        params['freight_type'] = this.state.freight_type;
        redirectURL.post("/lmconsignees/savelmsobzones",params).then((response)=>{
            console.log(response);
            if(response.data.message == "Success")
            {
                this.setState({
                    basicTitle: isEdit ? "Updated Successfully." : "Added Successfully.",
                    basicType : "success",
                    show : true,
                    controller : { open : false }
                })
                //window.location.reload();
                this.onLoadPageData();
            }
            else
            {
                // Show what the server actually said. It rejects a state that is already
                // mapped to another zone (one state -> one zone), and a bare
                // "Failed to update." would hide the reason and the zone it clashed with.
                this.setState({
                    basicTitle: response.data.message || "Failed to update.",
                    basicType : "warning",
                    show : true
                })
            }
        }).catch((e)=>{
            console.log(e);
            var serverMessage = (e && e.response && e.response.data && e.response.data.message)
                ? e.response.data.message : "";
            this.setState({
                basicTitle: serverMessage || "Failed to update.",
                basicType : "warning",
                show : true
            })
        })
}
buildSobFormResourceArray(isEdit, currentRow){
    currentRow = currentRow || {};
    var statesArray = this.state.statesList.map((each) => ({ label: each, value: each }));
    if(currentRow.state && !statesArray.some((each) => each.value === currentRow.state)){
        // Existing value doesn't match any known option (legacy/differently-cased data) -
        // include it as-is so the dropdown shows the record's actual saved value.
        statesArray = [{ label: currentRow.state, value: currentRow.state }].concat(statesArray);
    }
    var zonesArray = this.state.zonesList.map((each) => ({ label: each, value: each }));
    if(currentRow.zone && !zonesArray.some((each) => each.value === currentRow.zone)){
        zonesArray = [{ label: currentRow.zone, value: currentRow.zone }].concat(zonesArray);
    }
    return [
        {
            id: 0,
            title: "State",
            field: "state",
            type: "dropdown",
            optionsArray: statesArray,
            errMsg: "Please select the state.",
            is_active: true,
            is_disabled: !!isEdit,
            is_required: true
        },
        {
            id: 1,
            title: "Zone",
            field: "zone",
            // Was a fixed "dropdown" (hardcoded zonesList, couldn't add a new
            // zone without editing code) - creatable lets a user type a zone
            // that isn't in the list yet and use it directly.
            type: "creatable-dropdown",
            optionsArray: zonesArray,
            normalizeCase: true,
            // Per manager: a new zone name shouldn't allow spaces (existing
            // whitelist entries like "NORTH EAST" stay selectable as-is,
            // this only restricts what a user can newly type) - hyphens like
            // "ZONE-1" remain fine.
            blockSpaces: true,
            placeholder: "Select an existing zone, or type to add a new one",
            note: "Don't see the zone you need? Type its name (no spaces - use a hyphen instead) and press Enter to create it.",
            errMsg: "Please select or enter the zone.",
            is_active: true,
            is_disabled: false,
            is_required: true
        },
        {
            id: 2,
            title: "Default zone for this state",
            field: "is_default",
            type: "dropdown",
            optionsArray: [{ label: "Yes", value: 1 }, { label: "No", value: 0 }],
            note: "Needed only when the state is under more than one zone. A consignee with no Zone "
                + "on the Consignee master, whose city is not in Route Configuration or is under "
                + "several zones, plans in the default zone. Setting Yes here clears it on the "
                + "state's other zone.",
            is_active: true,
            is_disabled: false,
            is_required: false
        }
    ];
}
addNewRow()
{
    this.setState({
        controller: {
            open: true,
            title: "Add New SOB Zone",
            btnType: "Add",
            formResourceArray: this.buildSobFormResourceArray(false),
            type: "add",
            formData: {}
        }
    })
}
handleEdit = (params) => {
    this.setState({
        controller: {
            open: true,
            title: "Edit SOB Zone",
            btnType: "Update",
            formResourceArray: this.buildSobFormResourceArray(true, params.data),
            type: "update",
            formData: params.data || {}
        }
    })
};
handleDelete = async (params) => {
    this.onClickBulkDelete([params.data._id]);
};
ActionRenderer = (props) => (
    <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>
        <Edit className="text-primary cursor-pointer ml-2"
            size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleEdit(props) }} />
        <Trash className="text-danger cursor-pointer ml-2"
            size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleDelete(props) }} />
    </div>
);
onUpdateFreight = (object) => {
    this.updateLmStates({ ...object });
}
showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}
onClickDataExport(){
    var params = {
        fileName: "sob_zones.csv"
    };
    this.gridApi.exportDataAsCsv(params);
}
// Zones that will no longer exist once `rowIds` are deleted. A zone is still "in use" if any
// OTHER live row keeps it - a state can legitimately span zones, so deleting one of its rows
// does not necessarily retire the zone.
zonesFullyRemovedBy(rowIds){
    var ids = (rowIds || []).map(String);
    var going = {}, staying = {};
    (this.state.rowData || []).forEach((r) => {
        var z = String(r.zone || "").trim();
        if(!z) return;
        if(ids.indexOf(String(r._id)) !== -1){ going[z] = 1; } else { staying[z] = 1; }
    });
    return Object.keys(going).filter((z) => !staying[z]);
}

async onClickBulkDelete(array){
    var rowIds = array || [];
    console.log(rowIds,"rowIds")
    if(rowIds.length > 0)
    {
        // A zone is referenced from Route Config and from the Consignee master too. Deleting it
        // here while those still point at it would leave consignee mappings silently inert -
        // the engine ignores a zone the warehouse no longer configures - so show what else
        // refers to it BEFORE the delete, and clear the consignee mappings on confirm.
        var retiring = this.zonesFullyRemovedBy(rowIds);
        var impactLines = [];
        var clearZones = [];
        for(var zi = 0; zi < retiring.length; zi++){
            try{
                var imp = await redirectURL.post("/lmconsignees/getZoneRemovalImpact", {
                    loading_port_code: this.state.loading_port_code, zone: retiring[zi]
                });
                var d = imp.data || {};
                if((d.consignee_count || 0) > 0 || (d.route_row_count || 0) > 0){
                    impactLines.push(retiring[zi] + ": " + (d.consignee_count || 0)
                        + " consignee mapping(s), " + (d.route_row_count || 0)
                        + " route row(s) across " + (d.route_city_count || 0) + " city/cities");
                }
                if((d.consignee_count || 0) > 0){ clearZones.push(retiring[zi]); }
            }catch(e){ console.log(e); }
        }
        var qry = {
            rowIds:rowIds,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        // Same in-app dialog as every other message on this screen, instead of the browser's
        // own "<host> says" box.
        this.askConfirm({
            title : rowIds.length > 1 ? "Delete " + rowIds.length + " SOB zone records?" : "Delete this SOB zone record?",
            message : "A state left with no zone record at all cannot be planned - its consignees are dropped as \"No Zone Info\"."
                + (impactLines.length > 0
                    ? "  This also retires the zone, which is still referenced by - " + impactLines.join("; ")
                      + ". The consignee mappings will be cleared (those consignees fall back to their city/state zone); route rows are left for you to review."
                    : ""),
            confirmText : "Yes, delete",
            type : "warning",
            onConfirm : () => {
            redirectURL.post("/lmconsignees/deleteBulkLmSobZones",qry).then(async (response)=>{
                console.log(response.data);
                if(response.data.message == "Success")
                {
                    for(var ci = 0; ci < clearZones.length; ci++){
                        try{
                            await redirectURL.post("/lmconsignees/clearConsigneeZoneMappings", {
                                loading_port_code: this.state.loading_port_code, zone: clearZones[ci],
                                comp_code: this.state.comp_code,
                                user_name: localStorage.getItem('username'),
                                email: localStorage.getItem('email'),
                                user_department: localStorage.getItem('lm_department'),
                                staff_id: localStorage.getItem('staff_id'),
                                designation: localStorage.getItem('designation'),
                                user_role: localStorage.getItem('roles'),
                            });
                        }catch(e){ console.log(e); }
                    }
                    this.setState({
                        basicTitle:"Deleted Successfully.",
                        basicType : "success",
                        show : true,
                        rowIds : [],
                        selectedRows : []
                    })
                    //window.location.reload();
                    this.onLoadPageData();
                }
                else
                {
                    this.setState({
                        basicTitle:"Failed to Delete.",
                        basicType : "warning",
                        show : true
                    })
                }
            }).catch((e)=>{
                console.log(e);
            })
            }
        });
    }
    else
    {
        this.setState({
            basicTitle:"Please select the Row(s) to continue.",
            basicType : "warning",
            show : true
        })
    }
}
showBulkUpload(){
    this.setState({
        overly :"show-m",
        bulkslide : "slider-translate",
        errors: [],
        validData: [],
        fileName: ""
    })
}
handleFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = ""; // reset immediately

    if (!file) return;
    this.setState({ fileName: file.name })

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (event) => {
        const workbook = XLSX.read(
            new Uint8Array(event.target.result),
            { type: "array" }
        );
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
        this.validateExcelData(data);
    };
};
validateExcelData = (data) => {
    let errorList = [];
    let cleanedData = [];

    const validStates = this.state.statesList.map((each) => String(each).toUpperCase());
    // ONE STATE -> ONE ZONE. A state repeated in the file is ambiguous: nothing downstream
    // rejects two mappings for the same state, and the planning engine resolves the zone by
    // building a { state: zone } dict over the fetched rows, so the duplicate silently
    // becomes last-row-wins and the losing consignees plan in another zone - different
    // vehicle types, capacities, freight and SOB - with no error raised anywhere.
    // Caught here rather than letting the upload collapse it, so the user decides which zone.
    // A state MAY span zones (NCR vs upcountry), so a state on several rows is fine; what is
    // refused is the SAME (state, zone) pair twice, and more than one Default for a state.
    const pairRowNumbers = {};
    const defaultRowNumbers = {};
    const readDefault = (row) => {
        const raw = row["Default"] !== undefined ? row["Default"] : row["is_default"];
        const t = String(raw === undefined ? "" : raw).trim().toUpperCase();
        if (t === "") return null;
        if (["1", "Y", "YES", "TRUE"].indexOf(t) !== -1) return 1;
        if (["0", "N", "NO", "FALSE"].indexOf(t) !== -1) return 0;
        return "invalid";
    };
    data.forEach((row, index) => {
        const st = String(row["State"] || row["state"] || "").trim().toUpperCase();
        const zn = String(row["Zone"] || row["zone"] || "").trim().toUpperCase();
        if (!st) return;
        const pk = st + "|" + zn;
        if (!pairRowNumbers[pk]) pairRowNumbers[pk] = [];
        pairRowNumbers[pk].push(index + 2);
        if (readDefault(row) === 1) {
            if (!defaultRowNumbers[st]) defaultRowNumbers[st] = [];
            defaultRowNumbers[st].push(index + 2);
        }
    });

    data.forEach((row, index) => {
        const rowNumber = index + 2;

        let state = String(row["State"] || row["state"] || "").trim();
        let zone = String(row["Zone"] || row["zone"] || "").trim();

        let rowErrors = [];

        if (!state) {
            rowErrors.push("State is required");
        } else if (!validStates.includes(state.toUpperCase())) {
            rowErrors.push(`State "${state}" is invalid`);
        } else if (zone && pairRowNumbers[state.toUpperCase() + "|" + zone.toUpperCase()].length > 1) {
            rowErrors.push(
                `State "${state}" with zone "${zone}" appears on rows `
                + `${pairRowNumbers[state.toUpperCase() + "|" + zone.toUpperCase()].join(", ")} - keep one.`
            );
        } else if ((defaultRowNumbers[state.toUpperCase()] || []).length > 1) {
            rowErrors.push(
                `State "${state}" is marked Default on rows ${defaultRowNumbers[state.toUpperCase()].join(", ")} - `
                + `only one zone can be the state's default.`
            );
        }

        if (!zone) {
            rowErrors.push("Zone is required");
        }
        const defaultFlag = readDefault(row);
        if (defaultFlag === "invalid") {
            rowErrors.push("Default must be Yes or No (or left blank)");
        }
        // No longer rejecting zones outside a fixed list - see the Add/Edit
        // form, which now lets a user create a new zone the same way; bulk
        // upload has to accept whatever a manually-added zone could be too,
        // or the two paths would disagree about what's valid.

        if (rowErrors.length > 0) {
            errorList.push({
                row: rowNumber,
                errors: rowErrors
            });
        } else {
            // Normalize both to their canonical casing from statesList/zonesList
            // (e.g. "south" -> "SOUTH", "North East" -> "NORTH EAST") instead of
            // storing whatever case the file had - state used to be left as
            // whatever the user typed even though it was already validated
            // case-insensitively above.
            const canonicalState = this.state.statesList.find(
                (each) => String(each).toUpperCase() === state.toUpperCase()
            ) || state;
            // Match an already-known zone's exact casing if there is one, else
            // this is a genuinely new zone - normalize it to the same
            // uppercase convention the known ones use, rather than keeping
            // whatever case the uploaded file happened to have.
            const canonicalZone = this.state.zonesList.find(
                (each) => String(each).toUpperCase() === zone.toUpperCase()
            ) || zone.toUpperCase();
            cleanedData.push({
                state: canonicalState,
                zone: canonicalZone,
                // blank Default leaves the stored flag untouched on the server
                ...(defaultFlag === 0 || defaultFlag === 1 ? { is_default: defaultFlag } : {})
            });
        }
    });

    if (cleanedData.length === 0 && errorList.length === 0) {
        errorList.push({
            row: "",
            errors: ["No data found. All rows are empty"]
        });
    }

    this.setState({
        errors: errorList,
        validData: cleanedData
    });

    console.log("Valid Data:", cleanedData);
    console.log("Errors:", errorList);
};
handleBulkUpload = async () => {
    try {
        this.setState({
            loadshow: "show-m",
            overly: "show-m"
        })

        var reqParams = {
            csvData: this.state.validData,
            loading_port_code: this.state.loading_port_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            staff_id: localStorage.getItem('staff_id'),
            user_department: localStorage.getItem('lm_department'),
            designation: localStorage.getItem('designation'),
            comp_code: this.state.comp_code,
            user_role: localStorage.getItem('roles'),
            freight_type: this.state.freight_type,
        }
        const response = await redirectURL.post("/lmconsignees/savebulklmsobzones", reqParams);
        await this.onLoadPageData();
        this.setState({
            basicTitle: response.data.message,
            basicType: "success",
            show: true,
            loadshow: "show-n",
            overly: "show-n",
            bulkslide: "",
            errors: [],
            validData: [],
            fileName: "",
        })
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = "";
        }
    } catch (err) {
        console.error(err);
        this.setState({
            loadshow: "show-n",
            overly: "show-n",
        })
    }
};
getShortFileName = (name, maxLength = 31) => {
    const lastDot = name.lastIndexOf(".");
    const baseName = name.substring(0, lastDot);
    const extension = name.substring(lastDot);

    if (baseName.length <= maxLength) return name;

    return baseName.substring(0, maxLength) + "..." + extension;
};




onSelectBulkPlants= (location) =>{
    var plants=[];
    try{
        location.map(function(e){
            plants.push(e.value);
        })
        console.log(plants);
        this.setState({
            plant_name : plants
        });
    }
    catch(e)
    {
        console.log(e);
    }
    
}

onRowSelection(event){
    var rowIds=[];
    var rwCount = event.api.getSelectedNodes();
    rwCount.map((item) => {
        rowIds.push(item.data._id)
    });
    
    this.setState({
        rowIds:rowIds
    })
}
componentDidUpdate() {
    if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
        this._lastLoadingPortCode = this.context.loading_port_code;
        this.onGlobalPortChange();
    }
}
onGlobalPortChange = async () => {
    var selectedPlant = this.context.loading_port_code;
    if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
        // Not a valid port for this screen - keep this screen's own selection, don't refetch.
        return;
    }
    await this.pageAccess();
}
  render() {
    var duplicateStateZones = this.getDuplicateStateZones();
    var columnwithDefs = [
        {
            headerName: "",
            field: "_id",
            colId: "_id",
            width: 100,
            pinned: 'left',
            filter: false,resizable: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: "actionRenderer",
        },
        {
            headerName: "State",
            field: "state",
            width:250,
            filter: true,
            resizable: true,
            flex: 1,
        },
        {
            headerName: "Zone",
            field: "zone",
            width:200,
            filter: true,
            resizable: true,
            flex: 1,
        },
        {
            headerName: "Default",
            colId: "is_default",
            width: 120,
            filter: true,
            resizable: true,
            valueGetter: (params) => (this.isDefaultZoneRow(params.data) ? "Yes" : "No"),
        },
    ]
    return (
      <div class="container-fluid" style={{height: "100%"}}>
        <SweetAlert
            show={this.state.show}
            type={this.state.basicType}
            title={this.state.basicTitle}
            onConfirm={this.closeAlert}
        >
        </SweetAlert>

        {/* Confirmation dialog - same component the success/failure messages use, so a
            "are you sure" reads like the rest of the app instead of the browser's own
            "<host> says" box. Kept separate from the alert above because that one's
            onConfirm reloads the grid. */}
        <SweetAlert
            show={this.state.confirmAlert.open}
            type={this.state.confirmAlert.type}
            title={this.state.confirmAlert.title}
            showCancel
            confirmBtnText={this.state.confirmAlert.confirmText}
            cancelBtnText="Cancel"
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            onConfirm={this.onConfirmAccepted}
            onCancel={this.closeConfirm}
        >
            {this.state.confirmAlert.message}
        </SweetAlert>

        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>SOB Zones</h5>
                </div>
                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                    {(this.state.pageAccess == 3 && this.state.selectedRows.length > 0) ?
                    <button className="pill-btn pill-btn-danger" onClick={() => { this.onClickBulkDelete(this.state.selectedRows.map((each) => each._id)) }}>Delete</button>
                    : ""}
                    <button className="pill-btn pill-btn-primary" onClick={this.onClickDataExport.bind(this)}>Export Data</button>
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                    : ""}
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-success" onClick={this.addNewRow.bind(this)}>+ Add SOB Zone</button>
                    : ""}
                </div>
            </div>
            {/* Plain div, NOT `col-xl-12`: bootstrap's column classes carry `flex: 0 0 100%`,
                and inside this column-direction flex card that reads as flex-BASIS 100% of the
                HEIGHT - the banner took the whole card and squeezed the grid to nothing. The
                grid container below survives the same class only because its inline `flex: 1`
                overrides it. `flex: "0 0 auto"` keeps this strip at its content height. */}
            {(duplicateStateZones.length > 0) ?
            <div style={{ flex: "0 0 auto", padding: "0 15px" }}>
                <div style={{ background: "#fdecea", border: "1px solid #f5c2c0", borderRadius: "6px", padding: "10px 14px", marginBottom: "6px", fontSize: "13px", color: "#8a1c13" }}>
                    <strong>These states span more than one zone.</strong>{" "}
                    That is supported - e.g. some Haryana / Uttar Pradesh cities are DELHI NCR and the
                    rest are not. For each one, make sure every city is listed under the right zone in
                    Route Config, and that any consignee which must differ from its city carries a Zone
                    on the Consignee master. Anything left unmapped plans in the state's Default
                    zone. Click a state to see its rows:
                    <ul style={{ margin: "6px 0 0 0", paddingLeft: "18px" }}>
                        {duplicateStateZones.map((each) => (
                            <li key={each.state}>
                                <a href="#/" onClick={(ev) => { ev.preventDefault(); this.filterGridToState(each.state); }}
                                   style={{ color: "#8a1c13", fontWeight: 700, textDecoration: "underline" }}>
                                    {each.state}
                                </a>
                                {" "}&rarr; {each.zones.join(" , ")}
                                {" "}&middot;{" "}
                                {each.defaultZone
                                    ? <span>Default: <b>{each.defaultZone}</b></span>
                                    : <b>no Default set - edit one row and mark it Default</b>}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            : ""}

            {/* Rendered independently of the banner above: once the last duplicate is deleted the
                banner disappears, and a clear-filter link living inside it would vanish with it,
                leaving the grid silently filtered to one state. */}
            {(this.state.stateFilterApplied) ?
            <div style={{ flex: "0 0 auto", padding: "0 15px", marginBottom: "6px", fontSize: "13px" }}>
                Showing only <strong>{this.state.stateFilterApplied}</strong>.{" "}
                <a href="#/" onClick={(ev) => { ev.preventDefault(); this.clearGridStateFilter(); }}
                   style={{ textDecoration: "underline" }}>
                    Show all states
                </a>
            </div>
            : ""}
            <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                <div className="ag-theme-balham grid-wrapper mt-3 mb-3" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={this.gridRef}
                    modules={this.state.modules}
                    columnDefs={columnwithDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true, resizable: true
                    }}
                    rowData={this.state.rowData}
                    isExternalFilterPresent={this.isExternalFilterPresent}
                    doesExternalFilterPass={this.doesExternalFilterPass}
                    enableCharts={false}
                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                    onGridReady={this.onGridReady}
                    onGridState={this.onGridState}
                    frameworkComponents={this.state.frameworkComponents}
                    statusBar={this.state.statusBar}
                    sideBar={this.state.sideBar}
                    stopEditingWhenGridLosesFocus= {true}
                    paginationPageSize={this.state.paginationPageSize}
                    pagination={true}
                    gridOptions={{
                        context: { componentParent: this }
                    }}
                    // components={this.state.components}
                    enableRangeSelection= {true}
                    animateRows rowSelection={"multiple"}
                    rowHeight={45}
                    headerHeight={45}
                    onSelectionChanged={() => {
                        if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                            const selected = this.gridRef.current.api.getSelectedRows();
                            this.setState({ selectedRows: selected })
                        }
                    }} suppressRowClickSelection={true}
                    />
            </div>
            </div>
        </div>

        <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

            <div className="slider-header">
                Import Data
                <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
            </div>

            <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                <input
                    ref={this.fileInputRef}
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={this.handleFileChange}
                    style={{ display: "none" }}
                />
                <div className="d-flex align-items-center gap-3">
                    <button
                        className="btn btn-info d-flex justify-content-center p-3"
                        type="button"
                        onClick={() => this.fileInputRef.current.click()}
                    >
                        Upload File
                    </button>

                    <a href={require('../../assets/json/sample_lmsobzones.csv')} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                        Download Sample Template
                    </a>
                </div>

                {this.state.fileName && (
                    <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                        <span>Selected File :</span>
                        <span
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                flex: 1,
                                fontWeight: "bold"
                            }}
                            title={this.state.fileName}
                        >
                            {this.getShortFileName(this.state.fileName)}
                        </span>
                    </div>
                )}

                {this.state.errors.length > 0 && (
                    <>
                        <h6 className="text-danger mt-3">Validation Errors</h6>

                        <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                            <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                    <tr>
                                        <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                        <th>Error Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.state.errors.map((err, i) => (
                                        <tr key={i}>
                                            <td className="text-center" style={{ padding: "9px 15px" }}>
                                                {err.row}
                                            </td>

                                            <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                {err.errors.map((e, idx) => (
                                                    <p className="m-0" key={idx}>{e}</p>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

            </div>
            <div className="slider-footer">
                <button
                    className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: this.state.validData.length == 0 && "not-allowed", opacity: this.state.validData.length == 0 && "0.5" }}
                    onClick={this.handleBulkUpload}
                    disabled={this.state.validData.length == 0}
                >
                    {(this.state.errors.length > 0 && this.state.validData.length > 0) ? "Submit only valid data" : "Submit"}
                </button>
            </div>

        </div>
        {this.state.controller.open && (
            <>
                <div
                    className="slider-overlay"
                    onClick={() => { this.setState({ controller: { open: false } }) }}
                />
                <AddEditController
                    resource={this.state.controller}
                    onUpdate={this.onUpdateFreight}
                    closeSlider={() => { this.setState({ controller: { open: false } }) }}
                />
            </>
        )}
        <div className={"dataLoadpage " +(this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " +(this.state.loadshow)}>
            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
      </div>

    );
  }
}

function dateComparator1(date1,date2){
	//console.log(date1,date2);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split("-")[1]);
	date1 = date1.replace(date1.split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split("-")[1]);
	date2 = date2.replace(date2.split("-")[1],date_2);
	var date1Number = monthToComparableNumber1(date1);
	var date2Number = monthToComparableNumber1(date2);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}	
}

function monthToComparableNumber1(date) {
	console.log(date.length);
	console.log(date);
	if (date === undefined || date === null || date.length !== 10) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
	date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
	date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
	// console.log(date1,date2);
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	// console.log(date1Number,date2Number);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}
  }
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

function getMonthNumber(monthName){
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
		];
	var monthNum = months.indexOf(monthName)+1;
	if(monthNum < 10){
		monthNum = "0"+monthNum.toString();
	}
	return monthNum;
}


function loadDateTimeScript(){
	// alert("timeDate");
	$('.datetimepicker_mask').datetimepicker({
		//mask:'39-19-9999 29:59',
		format:'d-m-Y'
	});
	$('.datetimepicker_date').datetimepicker({
		mask:'39-19-9999',
		format:'d-m-Y',
		timepicker:false
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

function DateEditor () {}

// gets called once before the renderer is used
DateEditor.prototype.init = function(params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker:false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function() {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function() {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function() {
	// console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function() {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function() {
    // and we could leave this method out also, false is the default
    return false;
};

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr) || isCharDecimal(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};